import type { StaffCoordinationTaskResponse } from '@/types/apps/staff-coordination-customer.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Indexable } from '@/types/service/indexable.interface';

export interface StaffCoordinationTaskServiceInterface {}

type StaffCoordinationTaskListResponse = ApiResponse<
    PaginatedResult<StaffCoordinationTaskResponse>
>;

export class StaffCoordinationTaskService implements Indexable {
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        base: () => '/api/task-check',
    };

    public index(
        params?: QueryParams
    ): Promise<StaffCoordinationTaskListResponse> {
        return this.apiClient.fetchApi(this.endpoints.base(), params);
    }
}
